module.exports = __webpack_public_path__ + "static/media/bb.45c62450.svg";